<script setup lang="ts">
const props = defineProps(["panel", "index", "open"]);
const emit = defineEmits<{
  (e: "toggleOpen", index: number): void;
}>();
</script>

<template>
  <div class="acc-panel" :class="props.open ? 'panel open' : 'panel shut'">
    <div class="question" @click.prevent="emit('toggleOpen', props.index)">
      <h3>{{ panel.question || panel.title }}</h3>
      <i class="acc-plus">
        <div class="plus">
          <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <line x1="10" y1="10" x2="90" y2="90" stroke-width="10" />
            <line x1="90" y1="10" x2="10" y2="90" stroke-width="10" />
          </svg>
        </div>
      </i>
    </div>
    <div class="answer">
      <NuxtPicture
        v-if="panel.image?.url"
        class="acc-image"
        format="webp"
        preload
        :src="panel.image.url"
        :width="panel.image.width"
        :height="panel.image.height"
        :alt="panel.image.alt"
        sizes="sm:350px md:450px lg:550px"
      />
      <div v-if="panel.answer" v-html="panel.answer"></div>
      <div v-if="panel.text1" v-html="panel.text1"></div>
    </div>
  </div>
</template>
